import React, { useContext, useEffect, useState } from 'react'
import { IoIosArrowDown } from 'react-icons/io'

import ToastMessages from '../../components/ToastMessages'
import TopSearch from '../../components/TopSearch'
import Context from '../../context'
import { getSearch } from '../../services/ClubeApi'
import { getLoggedUser, isAuthenticated } from '../../services/auth'
import history from '../../services/history'

function CouponsPage() {
  const { setUser } = useContext(Context)
  const [searchData, setSearchData] = useState({ str: '', startSearch: false })
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (isAuthenticated) {
      setUser(getLoggedUser)
    } else {
      history.replace('/')
    }
  }, [])

  useEffect(() => {
    if (searchData.startSearch) {
      setIsLoading(true)
      getSearch('coupons', searchData.str).then(r => {
        // setChallengeList(r);
        setSearchData({ ...searchData, startSearch: false })
        setIsLoading(false)
      })
    }

    if (!searchData.startSearch && searchData.str === '') {
      // setPartnerList(fullPartnerList);
    }
  }, [searchData])

  return (
    <div className="container-fluid">
      <ToastMessages />
      <Context.Provider value={{ searchData, setSearchData }}>
        <TopSearch buttonLabel="Adicionar Cupom" goTo="/couponsform" searchAction={() => {}} />
      </Context.Provider>
      <div className="row">
        <div className="col">
          <ul className="nav nav-pills nav-fill">
            <li className="nav-item nav-item-left-text ">
              <h2 className="coupons-tab-active-item coupons-tab-item item-click">ATIVOS</h2>
            </li>
            <li className="nav-item nav-item-left-text">
              <h2 className="coupons-tab-item item-click">INATIVOS</h2>
            </li>
          </ul>
        </div>
      </div>
      <div className="row" style={{ padding: '20px', backgroundColor: 'lightgray' }}>
        <div className="col">PARCEIRO</div>
        <div className="col">QUANTIDADE</div>
        <div className="col">VALIDADE</div>
      </div>
      <div className="row" style={{ padding: '10px' }}>
        <div className="accordion-width" id="accordion">
          <div className="row">
            <div className="card col-12">
              <div
                className="card-header item-click row collapse-header"
                id="headingOne"
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                <div className="col coupons-header">Uber</div>
                <div className="col coupons-header">5.000</div>
                <div className="col coupons-header">Válido até 31/12</div>
                <div className="col-1" style={{ fontSize: '25px' }}>
                  <IoIosArrowDown />
                </div>
              </div>

              <div
                id="collapseOne"
                className="collapse show"
                aria-labelledby="headingOne"
                data-parent="#accordion"
              >
                <hr style={{ height: '2px' }} />
                <div className="card-body">
                  <div className="row">
                    <div className="col">
                      <div className="coupons-text text-club-blue">Restam ainda</div>
                      <div className="coupons-numbers text-club-blue">1200</div>
                    </div>
                    <div className="col">
                      <div className="coupons-text">Já foram usados</div>
                      <div className="coupons-numbers">3200</div>
                    </div>
                    <div className="col">
                      <div className="d-flex flex-row h-100 justify-content-center align-items-center align-items-center">
                        <div
                          className="coupons-text align-items-center"
                          style={{ marginRight: '10px' }}
                        >
                          Dias Restantes <br /> de Campanha
                        </div>
                        <div className="coupons-numbers flex-grow-1">25</div>
                      </div>
                    </div>
                    <div className="col-1">BAIXAR</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CouponsPage
